<template>
  <div
    class="p-5"
    style="padding: 20px; background-color: #fff; min-height: 500px"
  >
    <div class="flex flexwarp" style="justify-content: space-between">
      <div class="flex flexwarp">
        <div>
          <div class="flex">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;问题：</p>
            <el-input v-model="question" placeholder="请输入问题" clearable />
          </div>
          <div class="flex">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;回复：</p>
            <el-input v-model="content" placeholder="请输入回复" clearable />
          </div>
        </div>
        <div>
          <div class="flex">
            <p>回复时间：</p>
            <el-date-picker
              v-model="applyTime"
              type="daterange"
              style="width: 225px"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </div>
          <div class="flex">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;状态：</p>
            <el-select
              v-model="status"
              placeholder="请选择状态"
              style="width: 225px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="已回复" value="1"></el-option>
              <el-option label="待回复" value="2"></el-option>
              <el-option label="关闭" value="3"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div>
        <el-button @click="search" type="primary">搜索</el-button>
      </div>
      <el-button @click="toLeave" type="primary">去留言</el-button>
    </div>
    <div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="createTime" label="留言时间">
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="question" label="问题">
        </el-table-column>
        <el-table-column align="center" prop="content" label="回复">
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <!-- 0为待回复1为已回复2为关闭 -->
            <el-tag type="success" v-if="scope.row.status == 1">
              已回复
            </el-tag>
            <el-tag type="warning" v-if="scope.row.status == 0">
              待回复
            </el-tag>
            <el-tag type="danger" v-if="scope.row.status == 2"> 关闭 </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px 0; display: flex; justify-content: center">
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50]"
          hide-on-single-page
          layout="total,sizes, prev, pager, next"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 去留言弹窗 -->
    <LeaveDialog ref="leaveDialog" @refresh="getMessageList" />
    <!-- 详情弹窗 -->
    <LeaveDetail ref="leaveDetail" />
  </div>
</template>
<script>
import LeaveDetail from "./components/leaveDetail.vue";
import LeaveDialog from "./components/leaveDialog.vue";
import { getLeaveMessageList } from "@/api/moudles/user";
export default {
  data() {
    return {
      applyTime: [],
      status: "",
      content: "",
      question: "",
      leaveDialog: null,
      leaveDetail: null,
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  components: {
    LeaveDialog,
    LeaveDetail,
  },
  created() {
    this.getMessageList();
  },
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.getMessageList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getMessageList();
    },
    // formatDate 处理时间格式含有字符串 T 去掉T
    formatDate(date) {
      if (date) {
        return date.replace("T", " ");
      } else {
        return "";
      }
    },
    search() {
      this.currentPage = 1;
      if (this.applyTime == null) {
        this.applyTime = [];
      }
      this.getMessageList();
    },
    getMessageList() {
      getLeaveMessageList({
        data: {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          memberCode: this.$store.state.user.userInfo.memberCode,
          question: this.question,
          status: this.status,
          content: this.content,
          applyStartTime: this.applyTime.length > 0 ? this.applyTime[0] : "",
          applyEndTime: this.applyTime.length > 0 ? this.applyTime[1] : "",
        },
        success: (res) => {
          console.log("留言列表", res);
          if (res.data && res.data.list && res.data.list.length > 0) {
            this.tableData = res.data.list;
            this.totalNum = parseInt(res.data.total);
          } else {
            this.tableData = [];
            this.totalNum = 0;
          }
        },
      });
    },
    toLeave() {
      this.$refs.leaveDialog.open();
    },
    handleClick(row) {
      console.log(row);
      this.$refs.leaveDetail.open(row);
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
}
.flexwarp {
  flex-wrap: wrap;
}
.flex p {
  /* 文字不换行 */
  white-space: nowrap;
}
</style>
